<template>
	<div>
		<b-modal
			id="testConfg"
			v-model="localTestModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			size="lg"
			@hide="$emit('hide')"
		>
			<header
				class="d-flex align-items-center justify-content-between viewcon-border-bottom head"
			>
				<div
					class="font-lato fw-500 fs-18 color-black d-flex align-items-center gap-2"
				>
					<span v-if="testDetails.active">Edit Test</span>
					<span v-else>Activate Test</span>
				</div>
				<div @click="closetestmodal()">
					<img
						class="rotate-on-hover pointer"
						src="../../../assets/common-icons/blue-cross.svg"
						alt=""
					/>
				</div>
			</header>
			<div class="p-3">
				<b-row>
					<b-col cols="12">
						<div class="topDiv mt-3">
							<label class="viewcon-label"
								>Test Name &nbsp;<span class="asterik">*</span></label
							>
							<b-form-input
								@keyup.enter="handleNext()"
								class="viewcon-inputField"
								id="input-1"
								placeholder="Enter here"
								v-model.trim="$v.clone.name.$model"
								:class="{ error: $v.clone.name.$error }"
								autofocus
								type="text"
							></b-form-input>
							<div
								style="
                position: absolute;
                top: 5px;
                right: 12px;
                background-color: #fff;
              "
								v-if="$v.clone.name.$dirty && !$v.clone.name.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../../assets/deletepopupicon.svg" alt="" />
							</div>

							<div
								style="
                position: absolute;
                top: 5px;
                right: 12px;
                background-color: #fff;
              "
								v-if="!$v.clone.name.maxLength && $v.clone.name.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Should not exceed 128 characters',
								}"
								variant="primary"
							>
								<img src="../../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col cols="6">
						<div class="topDiv mt-3">
							<label class="viewcon-label"
								>Category<span class="asterik">*</span></label
							>
							<div
								ref="category-dropdown-button"
								@click="openCategoryDropdown = true"
								class="viewcon-select d-flex justify-content-between relativeclass"
								:class="{ error: $v.clone.categoryID.$error }"
							>
								<span class="text-truncate">{{
									clone.categoryID == null
										? "Select Category"
										: categories.find((c) => c.value == clone.categoryID).text
								}}</span>
								<span v-if="!openCategoryDropdown"
									><img src="@/assets/carrotdown.svg" alt="" class="mr-1"
								/></span>
								<span v-else
									><img src="@/assets/uparrow.svg" alt="" class="mr-1"
								/></span>
							</div>
							<div
								v-if="openCategoryDropdown"
								class="bct-checkboxcontainer pointer"
								ref="category-dropdown"
								v-closable="{
									exclude: ['category-dropdown-button', 'category-dropdown'],
									handler: 'closeCategoryDropdown',
								}"
							>
								<b-form-group class="qb-dd-group-ct">
									<b-form-radio-group
										class="bct-checboxtext radio-drp-dwn"
										:options="categories"
										v-model="clone.categoryID"
										@change="closeCategoryDropdown"
										buttons
										stacked
									>
									</b-form-radio-group>
								</b-form-group>
							</div>
						</div>
					</b-col>
					<b-col cols="6">
						<div class="topDiv mt-3">
							<label class="viewcon-label"
								>Sub Category<span class="asterik">*</span></label
							>
							<div
								ref="sub-category-dropdown-button"
								@click="
									clone.categoryID &&
										(openSubCategoryDropdown = !openSubCategoryDropdown)
								"
								class="viewcon-select d-flex justify-content-between relativeclass"
								:class="{
									'disabled-text': clone.categoryID == null,
									error: $v.clone.subCategoryID.$error,
								}"
							>
								<span class="text-truncate">{{
									clone.subCategoryID == null
										? "Select Sub Category"
										: subCategories[clone.categoryID].find(
												(c) => c.value == clone.subCategoryID
										  ).text
								}}</span>
								<span v-if="!openSubCategoryDropdown"
									><img src="../../../assets/carrotdown.svg" alt="" class="mr-1"
								/></span>
								<span v-else
									><img src="../../../assets/uparrow.svg" alt="" class="mr-1"
								/></span>
								<div
									style="position: absolute; top: 8px; right: 28px"
									v-if="
										$v.clone.subCategoryID.$dirty &&
											!$v.clone.subCategoryID.required
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="@/assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
							<div
								v-if="openSubCategoryDropdown"
								class="bct-checkboxcontainer pointer"
								ref="sub-category-dropdown"
								v-closable="{
									exclude: [
										'sub-category-dropdown-button',
										'sub-category-dropdown',
									],
									handler: 'closeSubCategoryDropdown',
								}"
							>
								<b-form-group class="qb-dd-group-ct">
									<b-form-radio-group
										class="bct-checboxtext radio-drp-dwn"
										:options="subCategories[clone.categoryID]"
										v-model="clone.subCategoryID"
										@change="closeSubCategoryDropdown"
										buttons
										stacked
									>
									</b-form-radio-group>
								</b-form-group>
							</div>
						</div>
					</b-col>
				</b-row>

				<!-- publicAvailability, Set Pricing, Leaderboard, Set Configuration removed — handled by PublicAvailability.vue -->

				<div class="d-flex justify-content-end mt-3">
					<b-button class="new-addBtn" @click="handleNext">
						{{ buttonName }}
					</b-button>
				</div>
			</div>
		</b-modal>
		<!-- ConfigExpiredModal, ViewAllConfigModal, AddConfigModal removed — handled by PublicAvailability.vue -->
	</div>
</template>

<script>
import { putTest } from "../../../utils/apiFunctions.js";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
// ViewAllConfigModal, AddConfigModal removed — handled by PublicAvailability.vue
import successToast from "@/views/mixin/toast.js";
import errorToast from "@/views/mixin/toast";

export default {
	name: "EditTest",

	props: {
		testModal: Boolean,
		testDetails: Object,
		topicID: String,
		context: Object,
		roles: Array,
	},
	mixins: [successToast, errorToast],
	components: {},
	data() {
		return {
			localTestModal: false,
			buttonName: "Update",
			clone: JSON.parse(JSON.stringify(this.testDetails)),
			openCategoryDropdown: false,
			openSubCategoryDropdown: false,
		};
	},
	validations: {
		clone: {
			name: {
				required,
				maxLength: maxLength(128),
			},
			categoryID: {
				required,
			},
			subCategoryID: {
				required,
			},
		},
	},
	watch: {
		"clone.categoryID"() {
			this.clone.subCategoryID = null;
		},
		testModal: {
			immediate: true,
			handler(val) {
				this.localTestModal = val;
			},
		},
		localTestModal(val) {
			this.$emit("update:testModal", val);
		},
	},
	computed: {
		...mapGetters("testVUEX", {
			categories: "getCategories",
			subCategories: "getSubCategories",
		}),
	},
	mounted() {
		this.updateButtonName();
	},
	methods: {
		updateButtonName() {
			this.buttonName = this.testDetails.active ? "Update" : "Activate";
		},
		handleNext() {
			if (this.testDetails.active) {
				this.editTest();
			} else {
				this.editModalTest();
			}
		},
		closeCategoryDropdown() {
			this.openCategoryDropdown = false;
		},
		closeSubCategoryDropdown() {
			this.openSubCategoryDropdown = false;
		},
		async editTest() {
			this.$v.clone.$touch();
			if (this.$v.clone.$invalid) {
				this.errorToast("Please fill all the mandatory fields");
				return;
			}
			try {
				const payload = {
					topicID: this.topicID,
					testID: this.clone.testID,
					name: this.clone.name,
					publicAvailability: this.clone.publicAvailability,
					categoryID: this.clone.categoryID,
					subCategoryID: this.clone.subCategoryID,
				};
				const response = await putTest({ ...payload });
				if (response.status === 200) {
					if (this.testDetails.testID === payload.testID) {
						this.testDetails.name = payload.name;
						this.testDetails.categoryID = payload.categoryID;
						this.testDetails.subCategoryID = payload.subCategoryID;
					}
					this.context.successToast("Test updated successfully!");
					this.$emit("resetSelTest");
					this.localTestModal = false;
					this.$emit("cardClose");
					this.$emit("lengthofTotalTopicsWhenedidted");
				} else if (response.status === 409) {
					this.context.errorToast("Test name already exists");
				} else {
					this.context.errorToast("Something went wrong!");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async editModalTest() {
			this.$v.clone.$touch();
			if (!this.$v.clone.$invalid) {
				try {
					const payload = {
						active: true,
						topicID: this.topicID,
						testID: this.clone.testID,
						name: this.clone.name,
						publicAvailability: this.clone.publicAvailability,
						categoryID: this.clone.categoryID,
						subCategoryID: this.clone.subCategoryID,
					};
					const response = await putTest(payload);
					if (response.status === 200) {
						this.$emit("resetPagination");
						setTimeout(() => {
							this.context.successToast("Test activated successfully!");
						}, 200);
						this.$emit("resetSelTest");
						this.localTestModal = false;
						this.$emit("cardClose");
					} else if (response.status === 409) {
						this.context.errorToast("Test name already exists");
					} else {
						this.context.errorToast("Something went wrong!");
					}
				} catch (error) {
					console.log(error);
				}
			}
		},
		closetestmodal() {
			this.localTestModal = false;
			this.$emit("cardClose");
			this.$emit("resetSelTest");
		},
	},
};
</script>
